import React, { Component } from "react";
import Loader from "../common/loader";

class Logs extends Component {
  render() {
    // console.log("props in log container --- ", this.props);

    const { loading, logsData, error } = this.props;

    if (loading) return <Loader />;

    if (error) return <p className="text-center">Something went wrong..</p>;

    if (!logsData.length) return <p className="text-center">Nothing to show</p>;
    // console.log("here erer +++++++++++++++++++++++", logsData.length);
    // console.log("here erer +++++++++++++++++++++++", !logsData.length);

    return (
      <React.Fragment>
        {logsData.length === 0 && (
          <p className="text-center">No message found.</p>
        )}
        {logsData &&
          logsData.length &&
          logsData.map((log, index) => (
            <li key={index} className="logs">
              <span className="log-user">{"<" + `${log.username}` + ">"}</span>{" "}
              <span style={{ color: "var(--logstext)" }}>{log.message}</span>
            </li>
          ))}
      </React.Fragment>
    );
  }
}

export default Logs;
